export enum POSApiType {
    ADYEN_LEM = "ADYEN_LEM",
    ADYEN_BP = "ADYEN_BP",
    ADYEN_PSP = "ADYEN_PSP",
}

export enum POSResultStatus {
    OK = "OK",
    FAILED = "FAILED",
}

export type ConnectionTestResult = Readonly<{
    api: POSApiType
    result: POSResultStatus
}>

export enum AdyenAccountHolderAgreementStatus {
    VALID = "VALID",
    INVALID = "INVALID",
    PENDING = "PENDING",
}

export type AdyenAccountHolder = Readonly<{
    id: string
    legalEntity: {
        id: string
    }
    supplier: {
        id: number
        name: string
    }
    agreement: {
        status: AdyenAccountHolderAgreementStatus
        updated: string
    }
    isLiable: boolean
}>

type DetailsId = Readonly<{
    id: string
}>

export type AdyenAccountHolderDetails = AdyenAccountHolder &
    Readonly<{
        balanceAccounts: Array<DetailsId>
        stores: Array<DetailsId>
    }>
